import React, { useState, useEffect } from 'react';
import { useAtomValue, useSetAtom } from 'jotai';
import useTranslate from '../../Hooks/useTranslate';
import { Box } from '@mui/material';
import useAPI from '../../api';
import { openSnackbarAdviseAtom, userBranchesAtom } from '../../Atoms';
import FiltersNavbar from './Components/FiltersNavbar';
import PivotWrapper from '../PivotReport/PivotWrapper';
import {
  DEFAULT_SLICE_TARGET_PIVOT,
  getMetadataTargetPivot,
} from '../PivotReport/utils/constant';
import {
  FullPageFlexBox,
  FullSizeColumn,
  FullSizeCenteredColumn,
} from '../../Components/FlexBox';
import RoundedTabs from '../../Components/Tabs';
import GraphsWrapper from './Components/GrapsWrapper';

const getThisMonthWavePeriod = () => {
  const currentDate = new Date();
  return (
    currentDate.getFullYear() +
    (currentDate.getMonth() + 1).toString().padStart(2, '0')
  );
};

const WaveActivitiesReport = function WaveActivitiesReport({ userRoles }) {
  const API = useAPI();
  const translate = useTranslate();
  const setOpenSnackbarAdvise = useSetAtom(openSnackbarAdviseAtom);
  const userBranches = useAtomValue(userBranchesAtom);

  const isOperator = Boolean(
    userRoles?.find(
      ({ roleId }) => roleId === 'OPERATOR' || roleId === 'LIMITEDOPERATOR'
    )
  );

  const [navbarOpen, setNavbarOpen] = useState(true);
  const [currentFilters, setCurrentFilters] = useState(null);
  const [reportData, setReportData] = useState(null);
  const [chartView, setChartView] = useState(
    isOperator
      ? true
      : localStorage.getItem('waveActivitiesReportChartView') === 'true'
  );

  useEffect(() => {
    const savedFilters = localStorage.getItem('waveActivitiesReportFilters');
    if (savedFilters) {
      setCurrentFilters(JSON.parse(savedFilters));
    } else {
      setCurrentFilters({
        wavePeriod: getThisMonthWavePeriod(),
        branchId: undefined,
      });
    }
  }, []);

  useEffect(() => {
    if (!currentFilters) return;

    API.getWaveReport(
      currentFilters?.wavePeriod,
      currentFilters?.branchId,
      (response) => {
        setReportData(response);
        localStorage.setItem(
          'waveActivitiesReportFilters',
          JSON.stringify(currentFilters)
        );
      },
      (error) => {
        setOpenSnackbarAdvise({
          severity: 'error',
          message: translate('ERROR'),
        });
      }
    );
  }, [currentFilters]);

  const handleToggleNavbar = () => {
    setNavbarOpen(!navbarOpen);
  };

  const toggleChartView = () => {
    setChartView(!chartView);
    localStorage.setItem(
      'waveActivitiesReportChartView',
      JSON.stringify(!chartView)
    );
  };

  const graphData = reportData?.graphData;
  const pivotData = reportData?.pivotData ?? [];

  const branchDescription = userBranches?.find(
    ({ id }) => id === currentFilters?.branchId
  )?.branchDescription;
  return (
    <FullPageFlexBox flexDirection="column" overflow="hidden">
      <FiltersNavbar
        title="WAVEACTIVITIESREPORT"
        toggle={handleToggleNavbar}
        open={navbarOpen}
        currentFilters={currentFilters}
        setCurrentFilters={setCurrentFilters}
        switchValue={chartView}
        switchLabel={
          !chartView ? translate('PIVOT_VIEW') : translate('CHART_VIEW')
        }
        onSwitchClick={toggleChartView}
      />
      <FullSizeColumn overflow="auto" padding="0px 24px">
        <FullSizeCenteredColumn
          display={!chartView ? 'none!important' : 'inherit!important'}
          gap="24px"
          justifyContent="flex-start"
          alignItems="center"
        >
          {graphData && (
            <GraphsWrapper
              graphData={graphData}
              wavePeriod={currentFilters?.wavePeriod}
              branchDescription={branchDescription}
            />
          )}
        </FullSizeCenteredColumn>
        <FullSizeColumn
          display={!chartView ? 'flex!important' : 'none!important'}
        >
          <PivotWrapper
            pivotType={5}
            data={pivotData}
            visible={!chartView}
            slice={DEFAULT_SLICE_TARGET_PIVOT}
            getMetadata={getMetadataTargetPivot}
            localStorageKey="waveActivitiesPivotReport"
            userRoles={userRoles}
          />
        </FullSizeColumn>
      </FullSizeColumn>
    </FullPageFlexBox>
  );
};

export default WaveActivitiesReport;
